import nav from './nav';
import modal from './modal';
import global from './woocommerce/global';

export default class App {
  constructor() {
    this.initDev();
    this.initBody();
  }

  initBody() {

  }

  initCore() {
    nav.init();
    modal.init();
    global.init();
  }

  initDev() {
  }
}

function LoadApp() {
  const app = new App();
  app.initCore();
}

if (document.readyState === 'loading') { 
  document.addEventListener('DOMContentLoaded', LoadApp); 
} else { 
  LoadApp(); 
}
